import { SxProps, Theme } from '@mui/material';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'secondary.main',
    alignSelf: 'flex-start',
    paddingX: '16px',
    borderRadius: '9px',
    alignItems: 'center',
  },
  dateContainer: {
    display: 'flex',
    gap: '30px',
    mt: '16px',
  },
  divider: { width: '100%', backgroundColor: 'common.blue400' },
  footerContainer: {
    display: 'flex',
    mt: '16px',
  },
  weekDayContainer: {
    flex: 1,
  },
  weekText: {
    fontSize: '14px',
    color: 'grey.800',
  },
  weekContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: 'primary.main',
    height: '20px',
    width: '20px',
    mr: '5px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
